// src/events/EventBus.js
import EventEmitter from 'eventemitter3';
export const EventBus = new EventEmitter();
